import { render, staticRenderFns } from "./PlatformManager.vue?vue&type=template&id=5d63a912&scoped=true&lang=pug&"
import script from "./PlatformManager.vue?vue&type=script&lang=ts&"
export * from "./PlatformManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d63a912",
  null
  
)

export default component.exports